const urlParams = new URLSearchParams(window.location.search);
const tag = urlParams.get('tag');

window.onload = function() {
    if (tag) {
        document.querySelector('[data-tag-title]').textContent = tag
        const articles = document.querySelectorAll('[data-tags]');

        if (articles.length === 0) return;

        articles.forEach(article => {
            const articleTags = article.getAttribute('data-tags');
            if (articleTags && !articleTags.includes(tag)) {
              article.style.display = 'none';
            }
        });
    }
}